
const initialState = {
  // Vocabulary
  isLoadingCategories: false,
  categories: {},
  selectedCategories: [],
  wordTypes: [
    { value: "", label: "Any" },
    { value: "adjective", label: "Adjective" },
    { value: "noun", label: "Noun" },
    { value: "verb", label: "Verb" },
    { value: "pronoun", label: "Pronoun" },
    { value: "adverb", label: "Adverb" },
    { value: "preposition", label: "Preposition" },
    { value: "interjection", label: "Interjection" },
  ],
  
  // Articulation
  sounds: { groups: [], options: [] },
  soundPositions: [
    { value: "start", label: "Initial" },
    { value: "medial", label: "Medial" },
    { value: "end", label: "Final" },
  ],
  selectedArticulationSounds: [],
  selectedArticulationSoundPositions: [],
  selectedExcludedWordsIds: [],
  // Num of syllables
  numOfSyllables: [],
  syllablesShapes: [],

  generateGameError: undefined,
  selectedGame: undefined,
  isLoadingGame: false,
  themes: [],
  grades: [
    { value: "PK-K", label: "PK-K" },
    { value: "1-2", label: "1-2" },
    { value: "3-4", label: "3-4" },
    { value: "5-6", label: "5-6" },
    { value: "7-9", label: "7-9" },
    { value: "10-12", label: "10-12" },
  ],
  ccssMeta: {},

  searchText: "",

  games: [],
  isLoadingGames: null,
  gamePlayList: [],
  formattedGamePlayList: [],
  isGamePlayListReady: false,

  areasOfNeed: [],
  objectivesColors: {},
  gamesRelations: {},
  isLoadingAreaOfNeeds: false,
  
  selectedFilter: null,

  trackEventsFunc: () => {},
};

export default initialState;
